
import CurrencyModal from '@library/components/Organisms/Modals/CurrencyModal.vue'
export default {
  name: 'SideNavCurrency',
  components: {CurrencyModal},
  data: () => ({
    openCurrencyModal: false,
    newCurrency: ''
  }),
  props: {
    currencyDefault: {
      type: String,
      default: 'EUR'
    },
    currencyHotel: {
      type: String,
      default: 'EUR'
    },
    currencyList: {
      type: Array,
      default: () => []
    },
    activeMenu: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => {}
    },
    currencySetted: {
      type: Boolean,
      default: false
    },
    currencyTitleMob: {
      type: String,
      default: 'Currencies'
    }
  },
  watch: {
    currencySetted(value) {
      if ((value = true)) {
        this.closeCurrencyModal()
      }
    }
  },
  computed: {
    processedCurrencyList() {
      return this.currencyList.map(currency => {
        if (currency.text) {
          const parts = currency.text.split(' ')
          return {
            ...currency,
            code: parts[0] || '',
            name: parts[1] || ''
          }
        } else {
          return {
            ...currency,
            code: '',
            name: ''
          }
        }
      })
    }
  },
  methods: {
    submit(currency) {
      this.openCurrencyModal = false
      this.$emit('changeCurrency', currency)
    },
    open(currency) {
      if (this.currencyDefault != currency.value && this.currencyHotel != currency.value && !window.location.href.includes('step2')) {
        this.newCurrency = currency.value
        this.openCurrencyModal = true
        this.$emit('openCurrencyModal', true)
      } else if (
        this.currencyDefault != currency.value &&
        (this.currencyHotel == currency.value || window.location.href.includes('step2'))
      ) {
        this.$emit('changeCurrency', currency.value)
      }
    },
    closeCurrencyModal() {
      this.openCurrencyModal = false
      this.$emit('openCurrencyModal', false)
    }
  }
}
